// Layout.js
import React from 'react';
import { Outlet } from 'react-router-dom';  // Outlet is where child routes will render
import ButtonAppBar from './ButtonAppBar'; // Assuming you have a ButtonAppBar component
import Box from '@mui/material/Box';
import EarlyAccessGate from './EarlyAccessGate';
import GlobalReleaseBanner from './GlobalReleaseBanner';
import EnvironmentBanner from './EnvironmentBanner';

const Layout = () => {
    return (
        <Box sx={{ width: '100%', maxWidth: '100%', minWidth: 0, overflowX: 'hidden' }}>
            <ButtonAppBar /> {/* This will appear on every page */}
            <EnvironmentBanner />
            <GlobalReleaseBanner />
            <EarlyAccessGate />
            <Box component="main" data-testid="app-main" sx={{ width: '100%', maxWidth: '100%', minWidth: 0, overflowX: 'hidden' }}>
                <Outlet /> {/* This renders the content of the active route */}
            </Box>
        </Box>
    );
};

export default Layout;
